import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import useScrollTo from '../../hooks/useScrollTo';
import useTimeout from '../../hooks/useTimeout';


function ScrollIntoView({children, listeners}) {

    const {ref, scrollTo} = useScrollTo();
    useEffect(() => {

        const {clear} = useTimeout(scrollTo, 250);

        return () => clear();
    }, listeners);

    return (
        <>
            <span
                ref={ref}
                style={
                    {
                        visibility: 'hidden'
                    }
                }
            />
            {children}
        </>
    );
}


ScrollIntoView.propTypes = {
    children: PropTypes.any,
    listeners: PropTypes.array
};

ScrollIntoView.defaultProps = {
    listeners: []
};


export default ScrollIntoView;
